import type {UserLevel} from '../constants';
import {getUserLevel} from './getUserLevel';
export {UserLevel} from '../constants';

export const currentUserMeetsUserLevel = (userLevel: UserLevel) =>
	getUserLevel() >= userLevel;

export default currentUserMeetsUserLevel;
